'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('../Button');

var _Button2 = _interopRequireDefault(_Button);

var _ModalContainer = require('../ModalContainer');

var _ModalContainer2 = _interopRequireDefault(_ModalContainer);

var _SearchDiscoverIcon = require('./SearchDiscoverIcon');

var _SearchDiscoverIcon2 = _interopRequireDefault(_SearchDiscoverIcon);

var _HumanForecastIcon = require('./HumanForecastIcon');

var _HumanForecastIcon2 = _interopRequireDefault(_HumanForecastIcon);

var _FavoritesIcon = require('./FavoritesIcon');

var _FavoritesIcon2 = _interopRequireDefault(_FavoritesIcon);

var _SwellDataIcon = require('./SwellDataIcon');

var _SwellDataIcon2 = _interopRequireDefault(_SwellDataIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IntroModal = function (_Component) {
  (0, _inherits3.default)(IntroModal, _Component);

  function IntroModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, IntroModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IntroModal.__proto__ || (0, _getPrototypeOf2.default)(IntroModal)).call.apply(_ref, [this].concat(args))), _this), _this.onboardMe = function (onboardingUrl) {
      window.location.assign(onboardingUrl);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(IntroModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isOpen = _props.isOpen,
          onClose = _props.onClose,
          onboardingUrl = _props.onboardingUrl;


      return _react2.default.createElement(
        _ModalContainer2.default,
        {
          isOpen: isOpen,
          onClose: onClose,
          contentLabel: 'See Whats New'
        },
        _react2.default.createElement(
          'div',
          { className: 'quiver-intro-modal' },
          _react2.default.createElement(
            'div',
            { className: 'quiver-intro-modal__header' },
            _react2.default.createElement(
              'h2',
              null,
              'See What\'s New'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'span',
                null,
                'We\'ve made some improvements to the Surfline experience.'
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'span',
                null,
                'Here\'s a look at some of the new features and updates.'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'quiver-intro-modal__items' },
            _react2.default.createElement(
              'div',
              { className: 'quiver-intro-modal__item' },
              _react2.default.createElement(_SearchDiscoverIcon2.default, null),
              _react2.default.createElement(
                'div',
                { className: 'quiver-intro-modal__item__text' },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Search and discover surf spots'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Use our rapid search to find cams and forecasts or our improved\n                  navigation and map view to discover new spots.'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'quiver-intro-modal__item' },
              _react2.default.createElement(_HumanForecastIcon2.default, null),
              _react2.default.createElement(
                'div',
                { className: 'quiver-intro-modal__item__text' },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Enhanced human forecast analysis'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Our trained surf forecasters now offer real time,\n                  detailed analysis for multiple regions around the world.'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'quiver-intro-modal__item' },
              _react2.default.createElement(_FavoritesIcon2.default, null),
              _react2.default.createElement(
                'div',
                { className: 'quiver-intro-modal__item__text' },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Easy access to favorites'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'You\'re never more than a click away from your favorite cams\n                  and reports anywhere on the site.'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'quiver-intro-modal__item' },
              _react2.default.createElement(_SwellDataIcon2.default, null),
              _react2.default.createElement(
                'div',
                { className: 'quiver-intro-modal__item__text' },
                _react2.default.createElement(
                  'h3',
                  null,
                  'More accurate swell data'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'We\'ve refined our surf forecasts using observations from\n                  our team of meteorologists and more frequent model updates.'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'quiver-intro-modal__options' },
            _react2.default.createElement(
              _Button2.default,
              {
                type: 'info',
                onClick: function onClick() {
                  return _this2.onboardMe(onboardingUrl);
                }
              },
              _react2.default.createElement(
                'span',
                { className: 'quiver-intro-modal__options__mobile--text' },
                'Learn More'
              ),
              _react2.default.createElement(
                'span',
                { className: 'quiver-intro-modal__options__desktop--text' },
                'See What\'s Changed'
              )
            ),
            _react2.default.createElement(
              _Button2.default,
              { onClick: onClose },
              'Done'
            )
          )
        )
      );
    }
  }]);
  return IntroModal;
}(_react.Component);

IntroModal.propTypes = {
  onboardingUrl: _propTypes2.default.string.isRequired,
  isOpen: _propTypes2.default.bool.isRequired,
  onClose: _propTypes2.default.func
};
IntroModal.defaultProps = {
  onClose: null
};
exports.default = IntroModal;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/IntroModal/IntroModal.js
// module id = 597
// module chunks = 11